import { render } from "./AddSecondaryStorage.vue?vue&type=template&id=01358434&scoped=true"
import script from "./AddSecondaryStorage.vue?vue&type=script&lang=js"
export * from "./AddSecondaryStorage.vue?vue&type=script&lang=js"

import "./AddSecondaryStorage.vue?vue&type=style&index=0&id=01358434&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01358434"]])

export default __exports__